import { storagePrefix, storagePrefixFixedV2, storagePrefixV2 } from '@/constant';

/* eslint-disable max-lines */
export interface ModelSolutionValue {
  id?: number;
  name?: string;
  type: 'spline' | 'circle' | 'image';
  imageConfig?: {
    url: string;
    size: number[]; // 分别代表宽高;
  };
  coord: number[] | number[][];
  groupCoord?: [number, number];
}

// 模型X坐标偏移量
const PIXEL_COORD_OFFSET_X = 12;

// 各穴位点对应的模型像素坐标
const ACUPOINT_PIXEL_COORD = {
  jianwaiyu: {
    left: [434, 368],
    right: [630, 368],
  },
  fufen: {
    left: [434, 396],
    right: [630, 396],
  },
  gaomang: {
    left: [434, 474],
    right: [630, 474],
  },
  shentang: {
    left: [434, 522],
    right: [630, 522],
  },
  geguan: {
    left: [434, 590],
    right: [630, 590],
  },
  yanggang: {
    left: [434, 706],
    right: [630, 706],
  },
  yishe: {
    left: [434, 725],
    right: [630, 725],
  },
  zhishi: {
    left: [434, 833],
    right: [630, 833],
  },
  guanyuanyuwai: {
    left: [434, 948],
    right: [630, 948],
  },
  baomang: {
    left: [434, 1001],
    right: [630, 1001],
  },
  jianzhongyu: {
    left: [458, 333],
    right: [605, 333],
  },
  tianzong: {
    left: [373, 475],
    right: [692, 475],
  },
  jianzhen: {
    left: [310, 475],
    right: [755, 475],
  },
  dazhu: {
    left: [483, 368],
    right: [581, 368],
  },
  fengmen: {
    left: [483, 396],
    right: [581, 396],
  },
  feiyu: {
    left: [483, 428],
    right: [581, 428],
  },
  jueyinyu: {
    left: [483, 474],
    right: [581, 474],
  },
  xinyu: {
    left: [483, 522],
    right: [581, 522],
  },
  duyu: {
    left: [483, 556],
    right: [581, 556],
  },
  geyu: {
    left: [483, 590],
    right: [581, 590],
  },
  xiaokeyu: {
    left: [483, 626],
    right: [581, 626],
  },
  ganyu: {
    left: [483, 668],
    right: [581, 668],
  },
  danyu: {
    left: [483, 706],
    right: [581, 706],
  },
  piyu: {
    left: [483, 725],
    right: [581, 725],
  },
  weiyu: {
    left: [483, 760],
    right: [581, 760],
  },
  sanjiaoyu: {
    left: [483, 793],
    right: [581, 793],
  },
  shenyu: {
    left: [483, 833],
    right: [581, 833],
  },
  qihaiyu: {
    left: [483, 878],
    right: [581, 878],
  },
  qihaiyuwai: {
    left: [434, 878],
    right: [630, 878],
  },
  dachangyu: {
    left: [483, 918],
    right: [581, 918],
  },
  dachangyuwai: {
    left: [458, 918],
    right: [605, 918],
  },
  guanyuanyu: {
    left: [483, 948],
    right: [581, 948],
  },
  pangguangyu: {
    left: [483, 1001],
    right: [581, 1001],
  },
  hunmen: {
    left: [434, 668],
    right: [630, 668],
  },
};

const PrimaryModelSolution: Omit<
  Record<Massage.ModelSolution, ModelSolutionValue[]>,
  | 'massage-yzc-zhai-dynamic'
  | 'massage-shoulder-lv-dynamic'
  | 'massage-shoulder-lv-v2-dynamic'
  | 'massage-waist-lv-dynamic'
  | 'shoulder-rf-lc-1'
  | 'shoulder-rf-lc-2'
  | 'shoulder-rf-sc-1'
  | 'shoulder-rf-route-1'
  | 'back-rf-route-1'
  | 'waist-rf-lc-1'
  | 'waist-rf-sc-1'
  | 'waist-rf-sc-2'
  | 'waist-rf-route-1'
  | 'waist-rf-route-2'
  | 'abdomen-rf-lc-1'
  | 'abdomen-rf-lc-clockwise-1'
  | 'custom-draw-line'
> = {
  shoulder: [
    {
      id: 1,
      type: 'spline',
      coord: [483, 396, 483, 706],
    },
    {
      id: 2,
      type: 'spline',
      coord: [483, 368, 483, 390, 476, 418, 470, 435, 458, 455, 440, 474],
    },
    {
      id: 3,
      type: 'spline',
      coord: [373, 475, 434, 706],
    },
    {
      id: 4,
      type: 'spline',
      coord: [483, 368, 434, 368],
    },
    {
      id: 5,
      type: 'spline',
      coord: [581, 396, 581, 706],
    },
    {
      id: 6,
      type: 'spline',
      coord: [581, 368, 581, 390, 588, 418, 594, 435, 606, 455, 630, 474],
    },
    {
      id: 7,
      type: 'spline',
      coord: [692, 475, 630, 706],
    },
    {
      id: 8,
      type: 'spline',
      coord: [581, 368, 630, 368],
    },
  ],
  'shock-shoulder-teacher-zhai': [
    {
      id: 1,
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['jianzhongyu'].left, ...ACUPOINT_PIXEL_COORD['geyu'].left],
    },
    {
      id: 2,
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['jianwaiyu'].left, ...ACUPOINT_PIXEL_COORD['geguan'].left],
    },
    {
      id: 3,
      type: 'spline',
      coord: [
        ...ACUPOINT_PIXEL_COORD['dazhu'].left,
        475,
        440,
        460,
        490,
        450,
        508,
        ...ACUPOINT_PIXEL_COORD['shentang'].left,
      ],
    },
    {
      id: 4,
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['jianzhongyu'].right, ...ACUPOINT_PIXEL_COORD['geyu'].right],
    },
    {
      id: 5,
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['jianwaiyu'].right, ...ACUPOINT_PIXEL_COORD['geguan'].right],
    },
    {
      id: 6,
      type: 'spline',
      coord: [
        ...ACUPOINT_PIXEL_COORD['dazhu'].right,
        589,
        440,
        604,
        490,
        614,
        508,
        ...ACUPOINT_PIXEL_COORD['shentang'].right,
      ],
    },
  ],
  back: [
    {
      id: 1,
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['qihaiyu'].left, ...ACUPOINT_PIXEL_COORD['ganyu'].left],
    },
    {
      id: 2,
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['qihaiyuwai'].left, ...ACUPOINT_PIXEL_COORD['hunmen'].left],
    },
    {
      id: 3,
      name: 'line3',
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['shenyu'].left, ...ACUPOINT_PIXEL_COORD['zhishi'].left],
    },
    {
      id: 4,
      name: 'line4',
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['qihaiyu'].left, ...ACUPOINT_PIXEL_COORD['qihaiyuwai'].left],
    },
    {
      id: 5,
      name: 'line5',
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['qihaiyu'].right, ...ACUPOINT_PIXEL_COORD['ganyu'].right],
    },
    {
      id: 6,
      name: 'line6',
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['qihaiyuwai'].right, ...ACUPOINT_PIXEL_COORD['hunmen'].right],
    },
    {
      id: 7,
      name: 'line7',
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['shenyu'].right, ...ACUPOINT_PIXEL_COORD['zhishi'].right],
    },
    {
      id: 8,
      name: 'line8',
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['qihaiyu'].right, ...ACUPOINT_PIXEL_COORD['qihaiyuwai'].right],
    },
  ],
  'shock-waist-teacher-zhai': [
    {
      id: 1,
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['ganyu'].left, ...ACUPOINT_PIXEL_COORD['qihaiyu'].left],
    },
    {
      id: 2,
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['yanggang'].left, ...ACUPOINT_PIXEL_COORD['qihaiyuwai'].left],
    },
    {
      id: 3,
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['ganyu'].right, ...ACUPOINT_PIXEL_COORD['qihaiyu'].right],
    },
    {
      id: 4,
      type: 'spline',
      coord: [...ACUPOINT_PIXEL_COORD['yanggang'].right, ...ACUPOINT_PIXEL_COORD['qihaiyuwai'].right],
    },
  ],
  'shock-shoulder-deji': [
    {
      id: 1,
      type: 'spline',
      coord: [
        [434, 368, 445, 370, 460, 380, 473, 390, 480, 402, 483, 417, 483, 706],
        [483, 706, 483, 417, 480, 402, 473, 390, 460, 380, 445, 370, 434, 368],
      ],
    },
    {
      id: 2,
      type: 'spline',
      coord: [
        [630, 368, 619, 370, 604, 380, 591, 390, 584, 402, 581, 417, 581, 706],
        [581, 706, 581, 417, 584, 402, 591, 390, 604, 380, 619, 370, 630, 368],
      ],
    },
  ],
  'shock-waist-deji': [
    {
      id: 1,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['weiyu'].left, 481, 850, 479, 890, 475, 900, 460, 910, 432, 918],
        [432, 918, 460, 910, 475, 900, 479, 890, 481, 850, ...ACUPOINT_PIXEL_COORD['weiyu'].left],
      ],
    },
    {
      id: 2,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['weiyu'].right, 583, 850, 585, 890, 589, 900, 604, 910, 632, 918],
        [632, 918, 604, 910, 589, 900, 585, 890, 583, 850, ...ACUPOINT_PIXEL_COORD['weiyu'].right],
      ],
    },
  ],
  'shock-shoulder-yst-1': [
    {
      id: 1,
      type: 'spline',
      coord: [
        [659, 400, 650, 400, 641, 402, 621, 407, 601, 417, 591, 432, 581, 462, ...ACUPOINT_PIXEL_COORD['geyu'].right],
        [...ACUPOINT_PIXEL_COORD['geyu'].right, 581, 462, 591, 432, 601, 417, 621, 407, 641, 402, 650, 400, 659, 400],
      ],
    },
    {
      id: 2,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['dazhu'].right, ...ACUPOINT_PIXEL_COORD['geyu'].right],
        [...ACUPOINT_PIXEL_COORD['geyu'].right, ...ACUPOINT_PIXEL_COORD['dazhu'].right],
      ],
    },
    {
      id: 3,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['jianwaiyu'].right, ...ACUPOINT_PIXEL_COORD['geguan'].right],
        [...ACUPOINT_PIXEL_COORD['geguan'].right, ...ACUPOINT_PIXEL_COORD['jianwaiyu'].right],
      ],
    },
    {
      id: 4,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['dazhu'].right, 581, 470, 591, 510, 611, 540, 631, 557, 660, 560],
        [660, 560, 631, 557, 611, 540, 591, 510, 581, 470, ...ACUPOINT_PIXEL_COORD['dazhu'].right],
      ],
    },
    {
      id: 5,
      type: 'spline',
      coord: [
        [405, 400, 414, 400, 423, 402, 443, 407, 463, 417, 473, 432, 483, 462, ...ACUPOINT_PIXEL_COORD['geyu'].left],
        [...ACUPOINT_PIXEL_COORD['geyu'].left, 483, 462, 473, 432, 463, 417, 443, 407, 423, 402, 414, 400, 405, 400],
      ],
    },
    {
      id: 6,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['dazhu'].left, ...ACUPOINT_PIXEL_COORD['geyu'].left],
        [...ACUPOINT_PIXEL_COORD['geyu'].left, ...ACUPOINT_PIXEL_COORD['dazhu'].left],
      ],
    },
    {
      id: 7,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['jianwaiyu'].left, ...ACUPOINT_PIXEL_COORD['geguan'].left],
        [...ACUPOINT_PIXEL_COORD['geguan'].left, ...ACUPOINT_PIXEL_COORD['jianwaiyu'].left],
      ],
    },
    {
      id: 8,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['dazhu'].left, 483, 470, 473, 510, 453, 540, 433, 557, 404, 560],
        [404, 560, 433, 557, 453, 540, 473, 510, 483, 470, ...ACUPOINT_PIXEL_COORD['dazhu'].left],
      ],
    },
  ],
  'shock-waist-yst-1': [
    {
      id: 1,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['piyu'].right, ...ACUPOINT_PIXEL_COORD['qihaiyu'].right],
        [...ACUPOINT_PIXEL_COORD['qihaiyu'].right, ...ACUPOINT_PIXEL_COORD['piyu'].right],
      ],
    },
    {
      id: 2,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['yishe'].right, ...ACUPOINT_PIXEL_COORD['qihaiyuwai'].right],
        [...ACUPOINT_PIXEL_COORD['qihaiyuwai'].right, ...ACUPOINT_PIXEL_COORD['yishe'].right],
      ],
    },
    {
      id: 3,
      type: 'spline',
      coord: [
        [
          ...ACUPOINT_PIXEL_COORD['piyu'].right,
          ...ACUPOINT_PIXEL_COORD['qihaiyu'].right,
          581,
          888,
          601,
          916,
          621,
          939,
          641,
          955,
          658,
          964,
        ],
        [
          658,
          964,
          641,
          955,
          621,
          939,
          601,
          916,
          581,
          888,
          ...ACUPOINT_PIXEL_COORD['qihaiyu'].right,
          ...ACUPOINT_PIXEL_COORD['piyu'].right,
        ],
      ],
    },
    {
      id: 4,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['piyu'].left, ...ACUPOINT_PIXEL_COORD['qihaiyu'].left],
        [...ACUPOINT_PIXEL_COORD['qihaiyu'].left, ...ACUPOINT_PIXEL_COORD['piyu'].left],
      ],
    },
    {
      id: 5,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['yishe'].left, ...ACUPOINT_PIXEL_COORD['qihaiyuwai'].left],
        [...ACUPOINT_PIXEL_COORD['qihaiyuwai'].left, ...ACUPOINT_PIXEL_COORD['yishe'].left],
      ],
    },
    {
      id: 6,
      type: 'spline',
      coord: [
        [
          ...ACUPOINT_PIXEL_COORD['piyu'].left,
          ...ACUPOINT_PIXEL_COORD['qihaiyu'].left,
          463,
          916,
          443,
          939,
          423,
          955,
          406,
          964,
        ],
        [
          406,
          964,
          423,
          955,
          443,
          939,
          463,
          916,
          ...ACUPOINT_PIXEL_COORD['qihaiyu'].left,
          ...ACUPOINT_PIXEL_COORD['piyu'].left,
        ],
      ],
    },
  ],
  'shock-waistback-yst-1': [
    {
      id: 1,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['dazhu'].right, ...ACUPOINT_PIXEL_COORD['guanyuanyu'].right],
        [...ACUPOINT_PIXEL_COORD['guanyuanyu'].right, ...ACUPOINT_PIXEL_COORD['dazhu'].right],
      ],
    },
    {
      id: 2,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['jianwaiyu'].right, ...ACUPOINT_PIXEL_COORD['guanyuanyuwai'].right],
        [...ACUPOINT_PIXEL_COORD['guanyuanyuwai'].right, ...ACUPOINT_PIXEL_COORD['jianwaiyu'].right],
      ],
    },
    {
      id: 3,
      type: 'spline',
      coord: [
        [
          ...ACUPOINT_PIXEL_COORD['dazhu'].right,
          581,
          490,
          586,
          530,
          591,
          550,
          601,
          568,
          611,
          578,
          ...ACUPOINT_PIXEL_COORD['geguan'].right,
        ],
        [
          ...ACUPOINT_PIXEL_COORD['geguan'].right,
          611,
          578,
          601,
          568,
          591,
          550,
          586,
          530,
          581,
          490,
          ...ACUPOINT_PIXEL_COORD['dazhu'].right,
        ],
      ],
    },
    {
      id: 4,
      type: 'spline',
      coord: [
        [
          ...ACUPOINT_PIXEL_COORD['piyu'].right,
          581,
          845,
          583,
          866,
          587,
          880,
          591,
          890,
          601,
          901,
          621,
          910,
          641,
          914,
          658,
          916,
        ],
        [
          658,
          916,
          641,
          914,
          621,
          910,
          601,
          901,
          591,
          890,
          587,
          880,
          583,
          866,
          581,
          845,
          ...ACUPOINT_PIXEL_COORD['piyu'].right,
        ],
      ],
    },
    {
      id: 5,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['dazhu'].left, ...ACUPOINT_PIXEL_COORD['guanyuanyu'].left],
        [...ACUPOINT_PIXEL_COORD['guanyuanyu'].left, ...ACUPOINT_PIXEL_COORD['dazhu'].left],
      ],
    },
    {
      id: 6,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['jianwaiyu'].left, ...ACUPOINT_PIXEL_COORD['guanyuanyuwai'].left],
        [...ACUPOINT_PIXEL_COORD['guanyuanyuwai'].left, ...ACUPOINT_PIXEL_COORD['jianwaiyu'].left],
      ],
    },
    {
      id: 7,
      type: 'spline',
      coord: [
        [
          ...ACUPOINT_PIXEL_COORD['dazhu'].left,
          483,
          490,
          478,
          530,
          473,
          550,
          463,
          568,
          453,
          578,
          ...ACUPOINT_PIXEL_COORD['geguan'].left,
        ],
        [
          ...ACUPOINT_PIXEL_COORD['geguan'].left,
          453,
          578,
          463,
          568,
          473,
          550,
          478,
          530,
          483,
          490,
          ...ACUPOINT_PIXEL_COORD['dazhu'].left,
        ],
      ],
    },
    {
      id: 8,
      type: 'spline',
      coord: [
        [
          ...ACUPOINT_PIXEL_COORD['piyu'].left,
          483,
          845,
          481,
          866,
          477,
          880,
          473,
          890,
          463,
          901,
          443,
          910,
          423,
          914,
          406,
          916,
        ],
        [
          406,
          916,
          423,
          914,
          443,
          910,
          463,
          901,
          473,
          890,
          477,
          880,
          481,
          866,
          483,
          845,
          ...ACUPOINT_PIXEL_COORD['piyu'].left,
        ],
      ],
    },
  ],
  'shock-waistback-yst-2': [
    {
      id: 1,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['dazhu'].right, ...ACUPOINT_PIXEL_COORD['qihaiyu'].right],
        [...ACUPOINT_PIXEL_COORD['guanyuanyu'].right, ...ACUPOINT_PIXEL_COORD['dazhu'].right],
      ],
    },
    {
      id: 2,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['dazhu'].left, ...ACUPOINT_PIXEL_COORD['qihaiyu'].left],
        [...ACUPOINT_PIXEL_COORD['guanyuanyu'].left, ...ACUPOINT_PIXEL_COORD['dazhu'].left],
      ],
    },
    {
      id: 3,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['jianwaiyu'].right, ...ACUPOINT_PIXEL_COORD['qihaiyuwai'].right],
        [...ACUPOINT_PIXEL_COORD['guanyuanyuwai'].right, ...ACUPOINT_PIXEL_COORD['jianwaiyu'].right],
      ],
    },
    {
      id: 4,
      type: 'spline',
      coord: [
        [...ACUPOINT_PIXEL_COORD['jianwaiyu'].left, ...ACUPOINT_PIXEL_COORD['qihaiyuwai'].left],
        [...ACUPOINT_PIXEL_COORD['guanyuanyuwai'].left, ...ACUPOINT_PIXEL_COORD['jianwaiyu'].left],
      ],
    },
    {
      id: 5,
      type: 'spline',
      coord: [
        [
          ...ACUPOINT_PIXEL_COORD['dazhu'].right,
          581,
          490,
          586,
          530,
          591,
          550,
          601,
          568,
          611,
          578,
          ...ACUPOINT_PIXEL_COORD['geguan'].right,
        ],
        [
          ...ACUPOINT_PIXEL_COORD['geguan'].right,
          611,
          578,
          601,
          568,
          591,
          550,
          586,
          530,
          581,
          490,
          ...ACUPOINT_PIXEL_COORD['dazhu'].right,
        ],
      ],
    },
    {
      id: 6,
      type: 'spline',
      coord: [
        [
          ...ACUPOINT_PIXEL_COORD['dazhu'].left,
          483,
          490,
          478,
          530,
          473,
          550,
          463,
          568,
          453,
          578,
          ...ACUPOINT_PIXEL_COORD['geguan'].left,
        ],
        [
          ...ACUPOINT_PIXEL_COORD['geguan'].left,
          453,
          578,
          463,
          568,
          473,
          550,
          478,
          530,
          483,
          490,
          ...ACUPOINT_PIXEL_COORD['dazhu'].left,
        ],
      ],
    },
    {
      id: 7,
      type: 'spline',
      coord: [
        [
          ...ACUPOINT_PIXEL_COORD['piyu'].right,
          581,
          845,
          583,
          866,
          587,
          880,
          591,
          890,
          601,
          901,
          621,
          910,
          641,
          914,
          658,
          916,
        ],
        [
          658,
          916,
          641,
          914,
          621,
          910,
          601,
          901,
          591,
          890,
          587,
          880,
          583,
          866,
          581,
          845,
          ...ACUPOINT_PIXEL_COORD['piyu'].right,
        ],
      ],
    },
    {
      id: 8,
      type: 'spline',
      coord: [
        [
          ...ACUPOINT_PIXEL_COORD['piyu'].left,
          483,
          845,
          481,
          866,
          477,
          880,
          473,
          890,
          463,
          901,
          443,
          910,
          423,
          914,
          406,
          916,
        ],
        [
          406,
          916,
          423,
          914,
          443,
          910,
          463,
          901,
          473,
          890,
          477,
          880,
          481,
          866,
          483,
          845,
          ...ACUPOINT_PIXEL_COORD['piyu'].left,
        ],
      ],
    },
  ],
  'back-RF': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefixV2 + '/3d-body-compare/asaadadad-min.png',
        size: [490, 700],
      },
      coord: [300, 290],
    },
  ],
  'shoulder-RF': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefixFixedV2 + '/model-texture/luuza3zo_159668.png',
        size: [480, 540],
      },
      coord: [308, 270],
    },
  ],
  'waist-RF': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefixFixedV2 + '/model-texture/luuz0jnr_713415.png',
        size: [480, 390],
      },
      coord: [305, 660],
    },
  ],
  'abdomen-RF': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefixFixedV2 + '/model-texture/luuxw8ma_832865.png',
        size: [400, 330],
      },
      coord: [340, 690],
    },
  ],
  'neck-RF': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefixFixedV2 + '/model-texture/luuy2pej_134555.png',
        size: [500, 300],
      },
      coord: [300, 240],
    },
  ],
  'massage-shoulder': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefix + '/model-texture/shoulder-texture.png',
        size: [540, 340],
      },
      coord: [285, 220],
    },
  ],
  'massage-waistback': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefix + '/model-texture/massage-texture-min.png',
        size: [500, 670],
      },
      coord: [290, 420],
    },
  ],
  'massage-waist': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefix + '/model-texture/waist-texture.png',
        size: [500, 460],
      },
      coord: [288, 585],
    },
  ],
  'massage-yzc-10-points': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefixFixedV2 + '/model-texture/massage-common-bg.png',
        size: [253, 670],
      },
      coord: [420, 340],
    },
  ],
  'massage-yzc': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefixFixedV2 + '/model-texture/massage-common-bg.png',
        size: [253, 670],
      },
      coord: [420, 340],
    },
  ],
  /**
   * @deprecated
   * 该方案已下架
   */
  'massage-shoulder-lv': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefixFixedV2 + '/model-texture/massage-lv-bg-min.png',
        size: [270, 405],
      },
      coord: [412, 415],
    },
  ],
  'massage-shoulder-lv-v2': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefixFixedV2 + '/model-texture/massage-lv-bg-min.png',
        size: [270, 240],
      },
      coord: [410, 335],
    },
  ],
  'massage-yzc-zhai': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefixFixedV2 + '/model-texture/massage-common-bg.png',
        size: [253, 520],
      },
      coord: [420, 405],
    },
  ],
  'shoulder-massage-yzc': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefix + '/model-texture/yzc-bg-6.png',
        size: [270, 340],
      },
      coord: [413, 330],
    },
  ],
  'waist-massage-yzc': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefixFixedV2 + '/model-texture/massage-common-bg.png',
        size: [260, 280],
      },
      coord: [417, 730],
    },
  ],
  'massage-waist-lv': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefixFixedV2 + '/model-texture/massage-common-bg.png',
        size: [265, 170],
      },
      coord: [411, 745],
    },
  ],
  'massage-neck': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefix + '/model-texture/texture-neck-massage.png',
        size: [260, 240],
      },
      coord: [420, 280],
    },
  ],
  'kungfu-shoulder': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefix + '/model-texture/back-texture.png',
        size: [550, 479],
      },
      coord: [262, 220],
    },
  ],
  moxibustion: [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefixV2 + '/effect-intro/adqfqfqf-min.png',
        size: [560, 345],
      },
      coord: [275, 245],
    },
    {
      name: 'image2',
      type: 'image',
      imageConfig: {
        url: storagePrefixV2 + '/effect-intro/qwfqwfg-min.png',
        size: [566, 270],
      },
      coord: [255, 450],
    },
    {
      name: 'image3',
      type: 'image',
      imageConfig: {
        url: storagePrefixV2 + '/effect-intro/rrhhfdg-min.png',
        size: [525, 300],
      },
      coord: [278, 570],
    },
    {
      name: 'image4',
      type: 'image',
      imageConfig: {
        url: storagePrefixV2 + '/effect-intro/dwqgqewg-min.png',
        size: [500, 240],
      },
      coord: [295, 725],
    },
    {
      name: 'image5',
      type: 'image',
      imageConfig: {
        url: storagePrefixV2 + '/effect-intro/wqdwqfgqw-min.png',
        size: [600, 280],
      },
      coord: [245, 830],
    },
  ],
  /** 矩阵式艾灸需要动态设置渲染区域，使用标准艾灸方案配置即可 */
  'matrix-moxibustion': [],
  /** 矩阵式艾灸腹部 */
  'matrix-moxibustion-abdomen': [],
  'normal-manual': [
    {
      name: 'image1',
      type: 'image',
      imageConfig: {
        url: storagePrefixFixedV2 + '/model-texture/normal-manual-bg.png',
        size: [460, 825],
      },
      coord: [320, 250],
    },
  ],
};

const formatCoord = (coord: number[][] | number[]) => {
  if (!coord?.length) return [];

  if (typeof coord?.[0] === 'number') {
    return coord?.map((item, index) => (index % 2 === 0 ? item + PIXEL_COORD_OFFSET_X : item));
  } else {
    return coord?.map(item => formatCoord(item));
  }
};

// 格式化模型spline模型坐标
export const ModelSolution: typeof PrimaryModelSolution = Object.entries(PrimaryModelSolution).reduce(
  (accur, [key, value]) => {
    accur[key] = value?.map(item => ({
      ...item,
      ...(item.type === 'spline' ? { coord: formatCoord(item?.coord) } : {}),
    }));

    return accur;
  },
  {} as any
);
